const state={
    showBool:false,
    showType:1,
    showMsg:'余额不足 请充值'
}
const mutations={
    WINDOWBOX_SHOW_HIDE(state,obj){
        state.showBool=true;
        state.showMsg=obj.msg;
        state.showType=obj.type||1;
    }
}
const actions={
    upDataWindowBoxShowBool({
        state,
        commit
    },obj){
        commit('WINDOWBOX_SHOW_HIDE',obj)
    }
}
const getters={}
export default{
    state,
    mutations,
    actions,
    getters
}